import clsx from 'clsx';
import type { CSSProperties } from 'react';

import classes from './PureLoadingScreen.module.scss';

export interface PureLoadingScreenProps {
	theme?: 'SYSTEM' | 'DARK' | 'LIGHT' | 'MOON';
	classNames?: Partial<{ root: string; loader: string }>;
	className?: string;
	style?: CSSProperties;
}

// Refer to /packages/shared/design-system/lib/components/ThemeProvider/use-custom-theme.tsx:27
const PureLoadingScreen = ({
	theme = (localStorage.getItem('custom-theme') as any) || 'SYSTEM',
	classNames,
	className,
	style = {},
}: PureLoadingScreenProps) => (
	<div
		data-component-id="pure-loading"
		data-theme={theme.toLowerCase()}
		className={clsx(classes.root, className, classNames?.root)}
		style={style}
	>
		<span className={clsx(classes.loader, classNames?.loader)} />
	</div>
);

export default PureLoadingScreen;
